import { useEffect, useRef, useState } from "react";

interface Props {
  title: string;
  open: boolean;
  submitting: boolean;
  onClose: () => void;
  onSubmit: (comment: string) => void;
}

export function CommentModal({ title, open, submitting, onClose, onSubmit }: Props) {
  const [text, setText] = useState("");
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (open) {
      setText("");
      setTimeout(() => ref.current?.focus(), 50);
    }
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="w-full sm:max-w-md rounded-t-2xl sm:rounded-2xl border border-border bg-card p-4 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-base font-semibold">コメント追記</h3>
        <p className="mt-1 text-xs text-muted-foreground truncate">{title}</p>
        <textarea
          ref={ref}
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={4}
          className="mt-3 w-full rounded-lg border border-input bg-background p-2 text-sm placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring"
          placeholder="Notion ページ末尾に GEN コメントとして追記されます"
          disabled={submitting}
        />
        <div className="mt-3 flex gap-2 justify-end">
          <button
            type="button"
            onClick={onClose}
            disabled={submitting}
            className="rounded-lg px-3 py-2 text-sm text-muted-foreground active:opacity-80 disabled:opacity-50"
          >
            キャンセル
          </button>
          <button
            type="button"
            onClick={() => onSubmit(text.trim())}
            disabled={submitting || text.trim() === ""}
            className="rounded-lg bg-primary text-primary-foreground px-4 py-2 text-sm font-medium active:opacity-80 disabled:opacity-50"
          >
            {submitting ? "送信中…" : "追記"}
          </button>
        </div>
      </div>
    </div>
  );
}
